var map = {
	"./ar/Customers": 8007,
	"./ar/Customers.js": 8007,
	"./ar/Exams": 6930,
	"./ar/Exams.js": 6930,
	"./ar/Notifications": 5742,
	"./ar/Notifications.js": 5742,
	"./ar/Plans": 5158,
	"./ar/Plans.js": 5158,
	"./ar/Products": 3385,
	"./ar/Products.js": 3385,
	"./ar/Profile": 5728,
	"./ar/Profile.js": 5728,
	"./ar/Samples": 8586,
	"./ar/Samples.js": 8586,
	"./ar/SpecialtyVisitMaterials": 7132,
	"./ar/SpecialtyVisitMaterials.js": 7132,
	"./ar/Visits": 5927,
	"./ar/Visits.js": 5927,
	"./en/Customers": 3693,
	"./en/Customers.js": 3693,
	"./en/Exams": 8096,
	"./en/Exams.js": 8096,
	"./en/Notifications": 5587,
	"./en/Notifications.js": 5587,
	"./en/Plans": 6861,
	"./en/Plans.js": 6861,
	"./en/Products": 5979,
	"./en/Products.js": 5979,
	"./en/Profile": 119,
	"./en/Profile.js": 119,
	"./en/Samples": 2476,
	"./en/Samples.js": 2476,
	"./en/SpecialtyVisitMaterials": 770,
	"./en/SpecialtyVisitMaterials.js": 770,
	"./en/Visits": 7305,
	"./en/Visits.js": 7305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2225;